<div>
  <iui-messages #messages class="ms-auto me-auto"></iui-messages>
</div>
<div *ngIf="!addPartnerBool && !updatePartnerBool" class="container-fluid">
  Below is a list of {{partnerTypeWithSpace}}s defined for use with your account.
  @if (partnerType === 'Brand') {
  These {{partnerTypeWithSpace}}s must pass vetting and verification before they
  can be associated with short code leases as the entity whose message content is being sent to wireless subscribers.
  Carriers require that {{partnerTypeWithSpace}}(s) be identified for a short code before it can be provisioned for messaging.
  }
  @else {
  These {{partnerTypeWithSpace}}s must pass vetting and verification before they
  can be associated with short code leases.
  Carriers require that a {{partnerTypeWithSpace}} be identified for a short code before it can be provisioned for messaging.
  }
  <p>

    <button class="btn btn-primary col-auto px-4 mb-2 mt-2" id="addPartner" (click)="displayAddPartner()">Add {{partnerTypeShort}}</button>

    @if (partnerType === 'ContentProvider') {
      <button class="btn btn-primary col-auto px-4 mb-2 mt-2 ms-2" id="downloadCpReport" (click)="downloadCpReport()">Download Original Content Providers Report</button>
    }
  </p>

  <div class="row">
    <div class="col-12">
      <p-table #tt styleClass="p-datatable-striped" [columns]="tableColumn" [value]="filteredPartners" [scrollable]="true" scrollHeight="50vh" dataKey="partnerId" id="tt" [paginator]="true"
        [rows]="100" sortMode="single" sortField="company" [defaultSortOrder]="1" (sortFunction)="customSort($event)" [customSort]="true"  [alwaysShowPaginator]="false"
        currentPageReportTemplate="(Displaying {first} to {last} of {totalRecords})" [showCurrentPageReport]="true" [globalFilterFields]="['company', 'partnerId', 'dba']">

        <ng-template pTemplate="paginatorright" let-state></ng-template>
        <ng-template pTemplate="caption">
          <div *ngIf="partners && partners.length > 0" class="row header">
            <div class="col-4">
              <form class="search-bar-form" style="width: 100%;">
                <input *ngIf="!checked" maxlength="60" type="text" class="search-bar-input" #globalSearch name="globalSearch" placeholder="Search" [(ngModel)]="brandClientInput"
                  (input)="tt.filterGlobal($any($event.target).value, 'contains')">
                <input *ngIf="checked" maxlength="60" type="text" class="search-bar-input" #globalSearch name="globalSearch" placeholder="Search" [(ngModel)]="feinInput"
                  (input)="tt.filterGlobal($any($event.target).value, 'contains')">
              </form>
            </div>
            <div class="col-4 d-flex search-slider-box justify-content-center align-items-center">
              
              <span [ngClass]="{'opacity': checked}" class="slider-text me-2">{{partnerTypeWithSpace}} / DBA</span>
              <p-inputSwitch [(ngModel)]="checked" (onChange)="onSlide()" name="SCONSlider" id="SCONSlider">
              </p-inputSwitch>
              <span [ngClass]="{'opacity': !checked}" class="slider-text ms-2">FEIN</span>
            </div>
            <div class="col-4 d-flex align-items-center filter-button-box">
     
                <button class="btn btn-primary me-2" (click)="toggleFilter();" id="shoHideBtn">{{filtersVisible ? "Hide Filters" : "Show Filters"}}</button>
                <button *ngIf="filtersVisible" class="btn btn-secondary" (click)="clearFilter()" id="clearBtn">Clear Filters</button>
             
            </div>
          

          </div>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
          <tr *ngIf="partners && partners.length > 0">

            <ng-container *ngFor="let col of columns">
              <th *ngIf="!col.sort" [style.width.%]="col.width">{{col.header}}</th>
              <th *ngIf="col.sort" class="noBorder" [style.width.%]="col.width" [pSortableColumn]="col.field">
                {{col.header}}
                <p-sortIcon [field]="col.field"></p-sortIcon>
              </th>
            </ng-container>
          </tr>
          <tr *ngIf="filtersVisible">
            <th class="small-column-flex-override"></th>
            <th class="list-header-filter"></th>
            <th class="list-header-filter"></th>
            <th class="list-header-filter"></th>
            <th class="list-header-filter">
              <p-columnFilter class="ellipsis filter-column" #vetStatusFil id="vetStatusFil" field="vetStatusAndReason" matchMode="in" [showMenu]="false">
                <ng-template pTemplate="filter" let-vetStatusFilter let-filterStatus="filterCallback">
                  <p-multiSelect #multiVetStatus id="multiVetStatus" appTid [ngModel]="vetStatusFilter" [options]="allVetStatus" appendTo="body" placeholder="Select" appendTo="body"
                  (onChange)="filterStatus($event.value)" optionLabel="label" optionValue="value" selectedItemsLabel="{0} items selected" [maxSelectedLabels]="2">
                  </p-multiSelect>
                </ng-template>
              </p-columnFilter>
            </th>
            <th class="list-header-filter">
             
            </th>
            <th class="list-header-filter"></th>
            
          
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <tr>

            <td *ngFor="let col of columns" class="noBorder ellipsis" [ngSwitch]="col.field">
              <div *ngSwitchCase="'updateTime'">
                {{rowData.updateTime | date:'M/d/yyyy'}}
              </div>

              <div *ngSwitchCase="'action'">

                <span>
                  <a href="javascript:void(0)" (click)="editPartner(rowData)">Edit</a>
                </span> <br>
                <span>
                  <a href="javascript:void(0)" (click)="getPreDeletePartnerData(rowData)">Delete</a>
                </span> <br>
              </div>
              <div *ngSwitchCase="'company'" [pTooltip]="rowData.company" tooltipPosition="top" appShowToolTipIfTruncated>
                {{rowData.company}}
              </div>
              <div *ngSwitchCase="'vetStatus'">
               @if (rowData.vetReportId !== undefined && rowData.vetReportId !== null) {
                <a href="" (click)="viewVetResults($event, rowData)"> {{rowData.vetStatus}} {{rowData.vetStatusReason}}</a>
               }
               @else {
                {{rowData.vetStatus}} {{rowData.vetStatusReason}}
               }
              </div>
              <div *ngSwitchDefault>{{rowData[col.field]}}</div>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage" let-columns>
          @if (!partners || partners.length === 0) {
          <tr>
            <td [attr.colspan]="columns.length" class="noBorder">
              There are currently no {{partnerTypeWithSpace}}s defined for your account.
            </td>
          </tr>
          }
        </ng-template>
      </p-table>
    </div>


  </div>
</div>

<div *ngIf="addPartnerBool" class="container-fluid">
  <app-add-partner [partnerType]="partnerType" (emitAction)="receiveChildEvent($event)"></app-add-partner>
</div>

<div *ngIf="updatePartnerBool" class="container-fluid">
  <app-update-partner [partnerType]="partnerType" (emitAction)="receiveChildEvent($event)" [partner]="partnerToEditObj" [scIdCount]="scIdCount">
  </app-update-partner>
</div>

<p-confirmDialog key='confirmDelete' #confirmDelete width="425" [closable]="true">
  <p-footer>
    <div class="d-flex justify-content-end">
      <button i18n id="scaccept" class="btn btn-primary me-2" (click)="confirmDelete.accept()">OK</button>
      <button i18n id="screject" class="btn btn-secondary" (click)="confirmDelete.reject()">Cancel</button>
    </div>
  </p-footer>
</p-confirmDialog>

<app-dynamic-dialog (whenComplete)="onDialogComplete($event)"></app-dynamic-dialog>